import { Getter } from 'vuex'
import { AuthState } from '../types'
import { RootState } from '@/store/types'

const isAuthenticated: Getter<AuthState, RootState> = ({ token, userId }) =>
  !!token && !!userId

export default isAuthenticated
